module.exports = __webpack_public_path__ + "static/vueboard-challenges-8fe86c4755e1e2ea4a4ed524ffc550f8.png";